
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({

    container: {
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
      },
      logotypeContainer: {
        // backgroundColor: theme.palette.primary.main,
        backgroundColor: '#12012C',
        width: '60%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          width: '50%',
        },
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },
      logotypeImage: {
        width: '100%',
        // height: '100vh',
      },
      logotypeText: {
        color: 'white',
        fontWeight: 500,
        fontSize: 84,
        [theme.breakpoints.down('md')]: {
          fontSize: 48,
        },
      },
      welcomeText: {
        fontWeight: '300!important',
      },

      noteText: {
        maxWidth: '320px',
        fontSize: '12px',
        marginTop: '2px',
        marginBottom: '24px',
        color: 'rgba(0,0,0,0.4)',
      },

      recoveryText: {
        marginTop: '20px',
      },
      customFormContainer: {
        width: '40%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        overflow: 'auto',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          width: '50%',
          overflow: 'visible',
        },
      },
      formContainer: {
        width: '40%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          width: '50%',
          overflow: 'visible',
        },
      },

      form: {
        width: 320,
      },

      formCenter: {
        justifyContent: 'center',
      },

      tab: {
        fontWeight: 400,
        fontSize: 18,
      },
      greeting: {
        fontWeight: 500,
        textAlign: 'center',
        marginTop: theme.spacing(4),
      },
      subGreeting: {
        fontWeight: 500,
        textAlign: 'center',
        marginTop: theme.spacing(2),
      },
      googleButton: {
        marginTop: theme.spacing(2),
        boxShadow: theme.customShadows.widget,
        backgroundColor: 'white',
        width: '100%',
        textTransform: 'none !important',

        '& .MuiButton-label': {
          textTransform: 'none !important',
        },
      },
      googleButtonCreating: {
        marginTop: 0,
      },
      googleIcon: {
        width: 30,
        marginRight: theme.spacing(2),
      },
      creatingButtonContainer: {
        marginTop: theme.spacing(2.5),
        height: 46,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      createAccountButton: {
        height: 46,
        textTransform: 'none',
      },
      formDividerContainer: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        display: 'flex',
        alignItems: 'center',
      },
      formDividerWord: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
      formDivider: {
        flexGrow: 1,
        height: 1,
        backgroundColor: theme.palette.text.hint,
      },
      errorMessage: {
        textAlign: 'center',
      },
      // lineUnderLogo: {
      //   '&:after': {
      //     content: '',
      //     width: '30px',
      //     height: '6px',
      //     // background: var(--logo_underline_color),
      //     display: 'block',
      //     margin: '1em auto',
      //   },
      // },
      textFieldUnderline: {
        '&:before': {
          borderBottomColor: theme.palette.primary.light,
        },
        '&:after': {
          borderBottomColor: theme.palette.primary.main,
        },
        '&:hover:before': {
          borderBottomColor: `${theme.palette.primary.light} !important`,
        },
      },
      textField: {
        borderBottomColor: theme.palette.background.light,
      },
      formButtons: {
        width: '100%',
        marginTop: theme.spacing(4),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      forgetButton: {
        textTransform: 'none',
        fontWeight: 500,
        fontSize: '14px',
        '&:hover': {
          textDecoration: 'underline',
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
      },
      verifyButton: {
        minWidth: '107px',
        minHeight: '41px',
        fontSize: '15px',
      },
      resendButton: {
        textTransform: 'none',
        fontWeight: 500,
        color: '#0C0644',
        padding: '0px',
        marginTop: '28px',
        fontSize: '15px',
        '&:hover': {
          textDecoration: 'underline',
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
      },
      // loginLoader: {
      //   marginLeft: theme.spacing(4),
      // },
      copyright: {
        marginTop: theme.spacing(4),
        whiteSpace: 'nowrap',
        position: 'fixed',
        bottom: '0',
        opacity: '0.7',
        [theme.breakpoints.up('md')]: {
          // bottom: theme.spacing(2),
        },
      },
      signUpSentence: {
        marginTop: '20px',
        fontSize: '12px',
      },
      signUpText: {
        display: 'inline',
        fontSize: '12px!important',
        fontWeight: '300!important',
      },
      signUpLink: {
        marginLeft: '5px',
        cursor: 'pointer',
        textDecoration: 'underline',
        fontWeight: '400',
      },

      logoImageContainer: ({ whiteLabelSettings }) => {
        function padding () {
          if (whiteLabelSettings && whiteLabelSettings?.labelName === 'ecal') {
            return '30px 20px 10px 0px';
          }
          return '';
        }

        return {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '72px',
          padding: padding(),
        };
      },

      logoImage: ({ whiteLabelSettings }) => {
        function logo () {
          if (whiteLabelSettings && whiteLabelSettings?.logo) {
            return whiteLabelSettings.logo;
          }
          return '';
        }

        return {
          backgroundSize: '150px',
          width: '150px',
          height: '30px',
          backgroundImage: `url(${logo()})`,
        };
      },

      openIdLogo: () => {
        return {
          width: 60,
          marginLeft: '16px',
        };
      },

      forgotPasswordBox: () => {
        return {
          width: 'calc(80%)',
        };
      },

      headerSpace: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      },

      headerTextTitle: {
        fontWeight: 'bold !important',
        textAlign: 'center',
        fontSize: '16px !important',
        marginTop: '16px',
        marginBottom: '8px',
      },

      headerText: {
        fontSize: '13px !important',
        textAlign: 'center',
        marginBottom: '16px',
      },

      loadingAnimationBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        maxWidth: '70px',
      },
});

export default styles;
export const useStyles = makeStyles(styles);
